import { ServiceBase } from '../../../../core/services/ServiceBase'
import AlertProxy from '../proxies/AlertProxy'

class AlertService extends ServiceBase {
  getAlertHighlight(params) {
    return this.getData(() => AlertProxy.getAlertHighlight(params))
  }
}

export default new AlertService()
